import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CodTransferForm from "./codTransferComponents/CodTransferForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import { useCreateCodTransferMutation } from "store/services/PaymentsApi/codTransferApi";

const CodTransferCreateScreen = () => {
  const navigate = useNavigate();
  const breadcrumbs = [
    {
      title: "COD Transfer",
      path: "/app/crm/cod-transfer/list",
    },
    {
      title: "New COD Transfer",
    },
  ];

  const [createCodTransfer, { isLoading: creatingCodTransfer }] =
    useCreateCodTransferMutation();

  const handleCodTransferCreate = async (data) => {
    try {
      await createCodTransfer(data).unwrap();
      navigate(breadcrumbs[0].path);
      toast.success("COD Transfer created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create COD Transfer!"
      );
    }
  };

  useAppMeta("New COD Transfer");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCodTransfer}>
      <BreadcrumbLayout.Paper>
        <CodTransferForm
          isBusy={creatingCodTransfer}
          onSubmit={handleCodTransferCreate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CodTransferCreateScreen;